import { Box, ButtonBase } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { useTracker } from '@dpdgroupuk/react-event-tracker';
import { ADD_ADDRESS_PICKUP_POINT } from '../../../constants/analytics';
import { getPickupAddress, getPickupInfo } from '../../../helpers/pickupPoint';
import PickupInfo from './PickupInfo';
import PickupDetails from './PickupDetails';
import AddressView from './AddressView';

const StyledButtonBase = styled(ButtonBase)(({ theme, isActive }) => ({
  width: '100%',
  display: 'block',
  textAlign: 'left',
  padding: theme.spacing(1, 3),
  backgroundColor: `${isActive ? theme.vars.palette.action.hover : 'none'}`,
  borderBottom: `1px solid ${theme.vars.palette.primary.borderLight}`,
  '&:hover': {
    backgroundColor: theme.vars.palette.action.hover,
  },
  '&:focus-visible': {
    outline: 'auto',
  },
}));

const PickupPointItemButtonsBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

const PickupPointItem = ({
  pickupPoint,
  onSelectClick,
  setActivePickupPoint,
  directionLink,
  isActive,
  showSelectButton,
  isModal,
  onChange,
  id,
}) => {
  const tracker = useTracker();
  const handleClick = () => {
    onSelectClick();
  };

  const onClose = () => {
    setActivePickupPoint(null);
  };

  return (
    <>
      <StyledButtonBase
        id={`pickup_point_item_${id}`}
        isActive={isActive}
        onClick={handleClick}
        tabIndex={0}
      >
        <Box sx={{ cursor: 'pointer' }}>
          <AddressView
            address={getPickupAddress(pickupPoint)}
            titleWidth='100%'
            pickupPoint={pickupPoint}
            id={id}
          />
          <PickupInfo
            showIsOpen={true}
            {...getPickupInfo(pickupPoint)}
            id={id}
          />{' '}
          <PickupPointItemButtonsBox />
        </Box>
      </StyledButtonBase>
      {isActive && (
        <PickupDetails
          pickupPoint={pickupPoint}
          directionLink={directionLink}
          showSelectButton={showSelectButton}
          isModal={isModal}
          onChange={onChange}
          onClose={onClose}
          onDirectionsClick={() => {
            tracker.logEvent(ADD_ADDRESS_PICKUP_POINT.ON_CLICK_DIRECTIONS);
          }}
          {...getPickupInfo(pickupPoint)}
        />
      )}
    </>
  );
};

PickupPointItem.propTypes = {
  number: PropTypes.number.isRequired,
  pickupPoint: PropTypes.object.isRequired,
  onSelectClick: PropTypes.func.isRequired,
  setActivePickupPoint: PropTypes.func,
  onPickupDetailsClick: PropTypes.func.isRequired,
  directionLink: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onDirectionsClick: PropTypes.func,
  showSelectButton: PropTypes.bool,
  id: PropTypes.string.isRequired,
};

export default PickupPointItem;
